import React from "react";

const ManageGrievancePage = () => {
  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Gerir Reclamação</h3>
      </div>
      <div className="card-body">
        <div className="bx--row">
          <div className="bx--col-lg-4">Total</div>
        </div>
      </div>
    </div>
  );
};

export default ManageGrievancePage;
